


















import {Component, Vue, Watch} from "vue-property-decorator";
import MillisecondDatePicker from '../../../../../shared/components/MillisecondDatePicker/index.vue';
import {debounce} from 'lodash';
import {PickingListReTransportParams} from "../../../params";
import {PickingListReTransportStore} from "@/modules/pickinglistretransport/store";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";

@Component({
    name: "PLReTransportSearch",
    components: {AInputBarCode, CustomerSelector, MillisecondDatePicker}
})
export default class extends Vue {
    form = new PickingListReTransportParams();

    @Watch("form", {immediate: false, deep: true})
    onSearch(val: any) {
        this.handleChangeSearch(val);
    }

    handleChangeSearch = debounce((val: any) => {
        PickingListReTransportStore.updatePickingListReTransportParams(val);
        PickingListReTransportStore.listPickingListReTransport({...val, page: 1});
    }, 500)

    onEnterPickingListCode(evt: any) {
        this.$set(this.form, 'search', evt?.target?.value || undefined);
    }
    
}
